export const carousel_images = [
    { file_name: 'Web-Banner-Sell-Your-Phone.png' },
    //{ file_name: 'buyback-banner.svg' },
    //{ file_name: 'Banner-06-02.png', link:"/partners/samsung" },
]
export const carousel_images_mobile = [
    { file_name: 'Mobile-Banner-Sell-Your-Phone.svg' },
    // { file_name: 'buyback-banner-mobile.svg' },
    //{ file_name: 'Mobile-version-BANNERS-02.png', link:"/partners/samsung" },
]
export const carousel_images_partners_mobile = [
    //{ file_name: 'samsung_banner.png' },
]

export const _carousel_images = [
    { file_name: 'buyback-banner.svg' },
    { file_name: 'sell-webBANNER-texts.png' },
    { file_name: 'Jess-solo-webBANNER-texts-2.png' },
    { file_name: 'Jess-mustapha-webBANNER-v3.png' },
]
export const ecommerce_carousel_images = [
    { file_name: 'Buyback-banner.png' },
    { file_name: 'sell-webBANNER-texts.png' },
    { file_name: 'Jess-solo-webBANNER-texts-2.png' },
    { file_name: 'Jess-mustapha-webBANNER-v3.png' },
]
export const _carousel_images_mobile = [
    { file_name: 'buyback-banner-mobile.svg' },
    { file_name: 'sell-webBANNER-texts-mobile.jpg' },
    { file_name: 'Banner-06-01.png' },
    { file_name: 'Jess-mustapha-webBANNER-v3-mobile.png' },
]

export const carousel_path = '/assets/images/hero/'
export const ecommerce_carousel_path = '/assets/images/hero/'
